module.exports = __webpack_public_path__ + "static/img/27.2f99421.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/政府部门/27.png
// module id = nIoO
// module chunks = 1